export const HEADER_HEIGHT = 55;

/** Top offset of the mobile wrapper when collapsedStyle is "dot" and chat is closed. */
export const MOBILE_DOT_WRAPPER_TOP = 65;
